import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { useAnalytics } from "@/components/AnalyticsProvider";
import NewsletterSignup from "@/components/NewsletterSignup";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_propmatch-7/artifacts/y6a3qiy4_LogotipoFinal_IkonicDeals%28web%29.jpg";

const Footer = () => {
  const { trackConversion } = useAnalytics();

  const handlePhoneClick = () => {
    trackConversion('phone_click', { location: 'footer' });
  };

  const handleEmailClick = () => {
    trackConversion('email_click', { location: 'footer' });
  };

  const handleWhatsAppClick = () => {
    trackConversion('whatsapp_click', { location: 'footer' });
  };

  return (
    <footer className="footer-section py-16 md:py-24" data-testid="footer">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Ikonic Deals" 
              className="h-20 md:h-24 w-auto mb-6"
            />
            <p className="text-[#A3A3A3] max-w-md leading-relaxed mb-8">
              Tu socio de confianza en el mercado inmobiliario guatemalteco. 
              Ofrecemos un servicio personalizado y profesional para la compra, 
              venta y alquiler de propiedades exclusivas.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://instagram.com/ikonicdealsgt" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-white/10 text-white/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all"
                data-testid="social-instagram"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="https://facebook.com/IkonicDealsGuatemala" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-white/10 text-white/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all"
                data-testid="social-facebook"
              >
                <Facebook size={18} />
              </a>
              <a 
                href={`https://wa.me/50242547204?text=${encodeURIComponent("¡Hola Ikonic Deals! 👋")}`}
                target="_blank" 
                rel="noopener noreferrer"
                onClick={handleWhatsAppClick}
                className="w-10 h-10 flex items-center justify-center border border-white/10 text-white/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all"
                data-testid="social-whatsapp"
              >
                <Phone size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">
              Navegación
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/comprar" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                  Comprar / Alquilar
                </Link>
              </li>
              <li>
                <Link to="/vender" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                  Vender / Alquilar
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <span className="text-[#A3A3A3]">
                  Av. Reforma 9-00, Zona 9<br />
                  Guatemala, Guatemala
                </span>
              </li>
              <li>
                <a 
                  href="tel:+50242547204" 
                  onClick={handlePhoneClick}
                  className="flex items-center gap-3 text-[#A3A3A3] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={18} className="text-[#D4AF37]" />
                  +502 4254-7204
                </a>
              </li>
              <li>
                <a 
                  href="mailto:hola@ikonicdeals.com" 
                  onClick={handleEmailClick}
                  className="flex items-center gap-3 text-[#A3A3A3] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={18} className="text-[#D4AF37]" />
                  hola@ikonicdeals.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Newsletter Section */}
        <div className="mt-12 pt-12 border-t border-white/5">
          <NewsletterSignup variant="compact" className="max-w-md" />
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#525252] text-sm">
            © {new Date().getFullYear()} Ikonic Deals. Todos los derechos reservados.
          </p>
          <p className="text-[#525252] text-sm">
            Diseñado con pasión en Guatemala
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
